/* eslint-disable no-shadow */
/* eslint-disable callback-return */
import _ from 'lodash';
import { codeGeneretor /* , keepObjectProperties */ } from 'app/utils';
// import { PAD_CARD_TYPES } from 'app/config/pad';
import { PAD_VISIT_TYPE } from 'app/config/padVisits';
// import { PRESCRIPTION_TYPE } from 'app/config/padCreator';
// import { FREQUENCY } from 'app/config/frequency_type';
// import { compareObjects } from '../../../utils';
const { CREATION, ALTERATION, SUSPENSION } = PAD_VISIT_TYPE;

const TEMPLATE_NAME = 'PAD_EDITOR';

// const STATUS = {
//   ACTIVE: 1,
//   INACTIVE: 0
// };
// const MEDICAMENT_PROPERTIES_COMPARE = [
//   // formOne -> PrescriptionTypeForm
//   'prescriptionType',
//   'medicamentId',
//   'evaluationTypeId',
//   'procedureId',
//   'NANDAProcedureId',
//   'dietId',
//   'supplied',
//   // formTwo -> PrescriptionMedicamentForm
//   'dose',
//   'frequencyAmount',
//   'frequencyId',
//   'administrationRouteId',
//   'instruction',
//   'justification',
//   'once',
//   'diluentId',
//   'diluentDose',
//   'asNeeded'
//   //'continuousUse',
//   // 'period'
// ];

// const NUTRITION_PROPERTIES_COMPARE = [
//   // formOne -> PrescriptionTypeForm
//   'prescriptionType',
//   'medicamentId',
//   'evaluationTypeId',
//   'procedureId',
//   'NANDAProcedureId',
//   'dietId',
//   'supplied',
//   // formTwo -> PrescriptionDietForm
//   'dose',
//   'frequencyAmount',
//   'frequencyId',
//   'administrationRouteId',
//   'instruction',
//   'justification',
//   'once',
//   'diluentId',
//   'diluentDose',
//   'asNeeded',
//   'timeStart',
//   'timeEnd'
//   //'continuousUse',
//   // 'period'
// ];

// const PROCEDURES_PROPERTIES_COMPARE = [
//   // formOne -> PrescriptionTypeForm
//   'prescriptionType',
//   'medicamentId',
//   'evaluationTypeId',
//   'procedureId',
//   'NANDAProcedureId',
//   'dietId',
//   'supplied',
//   // formTwo ->  PrescriptionProcedureForm
//   'procedureId',
//   'frequencyAmount',
//   'frequencyId',
//   'once',
//   'asNeeded',
//   'justification',
//   'instruction'
//   //'continuousUse',
//   //'period',
// ];

function buildPadVisit(padVisit) {
  this._padVisit = padVisit;

  this.addPadVisitCode = function (code) {
    this._padVisit.code = code;

    return this;
  };

  this.addPadVisitType = function (padVisitType) {
    this._padVisit.padVisitType = padVisitType;

    return this;
  };

  this.addPadVisitAlterId = function (padVisitAlterId) {
    this._padVisit.padVisitAlterId = padVisitAlterId;

    return this;
  };

  this.addStatus = function (status) {
    this._padVisit.status = status;

    return this;
  };

  this.getPadVisit = function () {
    return this._padVisit;
  };

  this.setPadVisit = function (padVisit) {
    this._padVisit = padVisit;

    return this;
  };

  this.setUpdateStatus = function () {
    this._padVisit.itHasBeenUpdated = true;

    return this;
  };
}

function buildPadVisits(padVisits, buildPadVisit) {
  this._padVisits = padVisits;

  this.add = function (padVisit) {
    this._padVisits = [...this._padVisits, padVisit];

    return this;
  };

  this.replace = function (padVisit) {
    this._padVisits = this._padVisits.map(pVisit => {
      if (pVisit.code === padVisit.code) {
        return buildPadVisit.setPadVisit(padVisit).getPadVisit();
      }
      return pVisit;
    });

    return this;
  };

  this.remove = function (code) {
    this._padVisits = this._padVisits.filter(pVisit => pVisit.code !== code);

    return this;
  };

  this.getPadVisits = function () {
    return this._padVisits;
  };
}

// function buildPadPrescription(padPrescription) {
//   this._convertInputFieldsToString = function (padPrescription) {
//     let cPadPrescription = {};
//     const inputFields = [
//       'description',
//       'frequencyAmount',
//       'totalAmount',
//       'dose',
//       'diluentDose',
//       'period'
//     ];

//     // eslint-disable-next-line no-unused-vars
//     for (const key in padPrescription) {
//       const value = padPrescription[key];
//       const isInputField = inputFields.includes(`${key}`);
//       cPadPrescription[key] = isInputField ? _.toString(value) : value;
//     }

//     return cPadPrescription;
//   };

//   this._padPrescription = this._convertInputFieldsToString(padPrescription);
//   /*
//   this.addPadPrescriptionCode = function () {
//     this._padPrescription.code = code;

//     return this;
//   };

//   this.addPadPrescriptionType = function () {
//     if (this._padPrescription.type === TYPE.CREATED || isNull(this._padPrescription.type)) {
//       this._padPrescription.type = TYPE.CREATED;
//     }
//     return this;
//   };
//   */
//   this.addStatus = function (status) {
//     this._padPrescription.status = status;
//     return this;
//   };

//   this.addPadCardType = function (padCardType) {
//     this._padPrescription.padCardType = padCardType;

//     return this;
//   };

//   this.addPadPrescriptionCode = function (code) {
//     this._padPrescription.code = code;

//     return this;
//   };

//   this.getType = function () {
//     const { EVALUATIONS, DIET, MEDS, PROCEDURES, NANDAPROCEDURE } = PRESCRIPTION_TYPE;

//     let prescriptionType = null;

//     if (this._padPrescription.dietId) {
//       prescriptionType = DIET;
//     }
//     if (this._padPrescription.medicamentId) {
//       prescriptionType = MEDS;
//     }
//     if (this._padPrescription.procedureId) {
//       prescriptionType = PROCEDURES;
//     }
//     if (this._padPrescription.NANDAProcedureId) {
//       prescriptionType = NANDAPROCEDURE;
//     }
//     if (this._padPrescription.evaluationTypeId) {
//       prescriptionType = EVALUATIONS;
//     }

//     return prescriptionType;
//   };

//   this.getFrequency = function () {
//     const frequencyInMinutes = this._padPrescription.frequency;

//     if (!frequencyInMinutes) return null;

//     const months = frequencyInMinutes % 43800;
//     const biweeks = frequencyInMinutes % 21600;
//     const weeks = frequencyInMinutes % 10080;
//     const days = frequencyInMinutes % 1440;
//     const hours = frequencyInMinutes % 60;

//     if (months === 0) {
//       const frequencyAmount = frequencyInMinutes / 43800;
//       const frequencyId = FREQUENCY.MONTH_ID;

//       return { frequencyAmount, frequencyId };
//     }
//     if (biweeks === 0) {
//       const frequencyAmount = frequencyInMinutes / 21600;
//       const frequencyId = FREQUENCY.BIWEEK_ID;

//       return { frequencyAmount, frequencyId };
//     }
//     if (weeks === 0) {
//       const frequencyAmount = frequencyInMinutes / 10080;
//       const frequencyId = FREQUENCY.WEEK_ID;

//       return { frequencyAmount, frequencyId };
//     }
//     if (days === 0) {
//       const frequencyAmount = frequencyInMinutes / 1440;
//       const frequencyId = FREQUENCY.DAY_ID;

//       return { frequencyAmount, frequencyId };
//     }
//     if (hours === 0) {
//       const frequencyAmount = frequencyInMinutes / 60;
//       const frequencyId = FREQUENCY.HOUR_ID;

//       return { frequencyAmount, frequencyId };
//     }

//     const frequencyAmount = frequencyInMinutes / 60;
//     const frequencyId = FREQUENCY.HOUR_ID;

//     return { frequencyAmount, frequencyId };
//   };

//   this.getPeriod = function () {
//     const periodInDays = this._padPrescription.period;

//     if (!periodInDays) return null;

//     const months = periodInDays % 30;
//     const biweeks = periodInDays % 15;
//     const weeks = periodInDays % 7;
//     const days = periodInDays % 1;

//     if (months === 0) {
//       const periodAmount = periodInDays / 30;
//       const periodFrequencyId = FREQUENCY.MONTH_ID;

//       return { periodAmount, periodFrequencyId };
//     }
//     if (biweeks === 0) {
//       const periodAmount = periodInDays / 15;
//       const periodFrequencyId = FREQUENCY.BIWEEK_ID;

//       return { periodAmount, periodFrequencyId };
//     }
//     if (weeks === 0) {
//       const periodAmount = periodInDays / 7;
//       const periodFrequencyId = FREQUENCY.WEEK_ID;

//       return { periodAmount, periodFrequencyId };
//     }
//     if (days === 0) {
//       const periodAmount = periodInDays / 1;
//       const periodFrequencyId = FREQUENCY.DAY_ID;

//       return { periodAmount, periodFrequencyId };
//     }
//   };

//   this.addFrequency = function (frequency) {
//     if (!frequency) return this;

//     const { frequencyAmount, frequencyId } = frequency;

//     this._padPrescription.frequencyAmount = frequencyAmount;
//     this._padPrescription.frequencyId = frequencyId;

//     return this;
//   };

//   this.addPeriod = function (period) {
//     if (!period) return this;

//     const { periodAmount, periodFrequencyId } = period;

//     this._padPrescription.periodAmount = periodAmount;
//     this._padPrescription.periodFrequencyId = periodFrequencyId;

//     return this;
//   };

//   this.addPrescriptionType = function (prescriptionType) {
//     this._padPrescription.prescriptionType = prescriptionType;

//     return this;
//   };

//   this.getPadPrescription = function () {
//     return this._padPrescription;
//   };

//   this.cleanPadPrescription = function (callback) {
//     const {
//       diet,
//       medicament,
//       administrationRoute,
//       diluent,
//       nandaProcedure,
//       procedure,
//       evaluationType
//     } = this._padPrescription;

//     this._padPrescription.diet = callback(diet, ['id', 'name']);
//     this._padPrescription.diluent = callback(diluent, ['id', 'name']);
//     this._padPrescription.procedure = callback(procedure, ['id', 'name']);
//     this._padPrescription.medicament = callback(medicament, ['id', 'name']);
//     this._padPrescription.nandaProcedure = callback(nandaProcedure, ['id', 'name']);
//     this._padPrescription.evaluationType = callback(evaluationType, ['id', 'name']);
//     this._padPrescription.administrationRoute = callback(administrationRoute, ['id', 'name']);

//     // delete this._padPrescription.id;
//     //delete this._padPrescription.code;

//     delete this._padPrescription.pad;
//     // delete this._padPrescription.padId;

//     delete this._padPrescription.padVisits;
//     delete this._padPrescription.professional;

//     delete this._padPrescription.created;
//     delete this._padPrescription.updated;

//     return this;
//   };

//   this.setPadPrescription = function (padPrescription) {
//     this._padPrescription = padPrescription;

//     return this;
//   };
//   this.setUpdateStatus = function () {
//     this._padPrescription.itHasBeenUpdated = true;

//     return this;
//   };
//   this.cleanToCompareForm = function () {
//     delete this._padPrescription.unityDiet;
//     delete this._padPrescription.unityDiluent;
//     delete this._padPrescription.unityMat;
//     delete this._padPrescription.nandaProcedure;
//     delete this._padPrescription.frequencyAmount;
//     delete this._padPrescription.frequencyId;
//     delete this._padPrescription.evaluationType;
//     delete this._padPrescription.evaluationTypeId;
//     delete this._padPrescription.digitalSignature;
//     delete this._padPrescription.padCardType;
//     return this;
//   };
// }
// function buildPadPrescriptions(padPrescriptions, buildPadPrescription) {
//   this._padPrescriptions = padPrescriptions;

//   this.add = function (padPrescription) {
//     this._padPrescriptions = [...this._padPrescriptions, padPrescription];

//     return this;
//   };

//   this.replace = function (padPrescription) {
//     this._padPrescriptions = this._padPrescriptions.map(pPrescription => {
//       if (pPrescription.code === padPrescription.code) {
//         return buildPadPrescription.setPadPrescription(padPrescription).getPadPrescription();
//       }
//       return pPrescription;
//     });

//     return this;
//   };

//   this.remove = function (code) {
//     this._padPrescriptions = this._padPrescriptions.filter(
//       pPrescription => pPrescription.code !== code
//     );

//     return this;
//   };

//   this.getPadPrescriptions = function () {
//     return this._padPrescriptions;
//   };
// }
function buildPadDiagnostic(padDiagnostic) {
  this._padDiagnostic = padDiagnostic;

  this.addPadDiagnosticCode = function (code) {
    this._padDiagnostic.code = code;

    return this;
  };

  this.setUpdateStatus = function () {
    this._padDiagnostic.itHasBeenUpdated = true;

    return this;
  };

  this.addPadDiagnosticAlterId = function (padDiagnosticAlterId) {
    this._padDiagnostic.padDiagnosticAlterId = padDiagnosticAlterId;

    return this;
  };

  this.addPadDiagnosticType = function (type) {
    this._padDiagnostic.padDiagnosticType = type;

    return this;
  };

  this.setPadDiagnostic = function (padDiagnostic) {
    this._padDiagnostic = padDiagnostic;

    return this;
  };

  this.addPadDiagnosticType = function (padDiagnosticType) {
    this._padDiagnostic.padDiagnosticType = padDiagnosticType;

    return this;
  };

  this.addPadCardType = function (padCardType) {
    this._padDiagnostic.padCardType = padCardType;

    return this;
  };

  this.addStatus = function (status) {
    this._padDiagnostic.status = status;
    return this;
  };

  this.cleanPadDiagnostic = function (/*callback*/) {
    return this;
  };

  this.getPadDiagnostic = function () {
    return this._padDiagnostic;
  };
}

function buildPadDiagnostics(padDiagnostics, buildPadDiagnostic) {
  this._padDiagnostics = padDiagnostics;

  this.add = function (padDiagnostic) {
    this._padDiagnostics = [...this._padDiagnostics, padDiagnostic];

    return this;
  };

  this.replace = function (padDiagnostic) {
    this._padDiagnostics = this._padDiagnostics.map(pDiagnostic => {
      if (pDiagnostic.code === padDiagnostic.code) {
        return buildPadDiagnostic.setPadDiagnostic(padDiagnostic).getPadDiagnostic();
      }
      return pDiagnostic;
    });

    this.getPadDiagnostics = function () {
      return this._padDiagnostics;
    };

    return this;
  };

  this.remove = function (code) {
    this._padDiagnostics = this._padDiagnostics.filter(pDiagnostic => pDiagnostic.code !== code);

    return this;
  };

  this.getPadDiagnostics = function () {
    return this._padDiagnostics;
  };
}

const preparePadVisits = padVisits => {
  return padVisits.map(padVisit => {
    const code = padVisit.code ? padVisit.code : codeGeneretor();

    return new buildPadVisit(padVisit)
      .addPadVisitCode(code) /* .addStatus(1) */
      .getPadVisit();
  });
};
// const comparePrescription = (cPRescription, nPrescription) => {
//   const { /* medicamentId,  */ procedureId, dietId, NANDAProcedureId } = cPRescription;
//   /*   const isMedicamentId = !_.isNull(medicamentId) && medicamentId === nPrescription.medicamentId;
//    */ const isProcedureId = !_.isNull(procedureId) && procedureId === nPrescription.procedureId;
//   const isDietId = !_.isNull(dietId) && dietId === nPrescription.dietId;
//   const isNANDAProcedureId =
//     !_.isNull(NANDAProcedureId) && NANDAProcedureId === nPrescription.NANDAProcedureId;

//   return /* isMedicamentId || */ isProcedureId || isDietId || isNANDAProcedureId;
// };
// const preparePadPrescription = (padPrescriptions, padId = null) => {
//   return padPrescriptions
//     .filter(padPrescription => !padId || padPrescription.padId === padId)
//     .filter(padPrescription => padPrescription.status === STATUS.ACTIVE)
//     .map(padPrescription => {
//       const prescriptionType = new buildPadPrescription(padPrescription).getType();
//       const frequency = new buildPadPrescription(padPrescription).getFrequency();
//       // const period = new buildPadPrescription(padPrescription).getPeriod();

//       return (
//         new buildPadPrescription(padPrescription)
//           .cleanPadPrescription(keepObjectProperties)
//           .addPadCardType(PAD_CARD_TYPES.PRESCRIPTION)
//           .addPrescriptionType(prescriptionType)
//           .addFrequency(frequency)
//           // .addPeriod(period)
//           //.addPadPrescriptionType()
//           //.addPadPrescriptionCode()
//           // .addStatus(1)
//           .getPadPrescription()
//       );
//     });
// };

// const preparePadDiagnostic = (padDiagnostics, padId = null) => {
//   return padDiagnostics
//     .filter(padDiagnostic => !padId || padDiagnostic.padId === padId)
//     .map(padDiagnostic => {
//       return new buildPadDiagnostic(padDiagnostic).getpadDiagnostic();
//     });
// };

const initialState = () => ({
  loading: false,
  pad: {
    loadedData: {}
  },
  padVisits: {
    loadedData: [],
    screenData: [],
    submitData: []
  },
  // padPrescription: {
  //   loadedData: [],
  //   screenData: [],
  //   submitData: []
  // },
  padDiagnostic: {
    loadedData: [],
    screenData: [],
    submitData: []
  }
  // padItem: {
  //   loadedData: [],
  //   screenData: [],
  //   submitData: []
  // }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = _.cloneDeep(action.payload);
      const { pad, padVisits, /* padPrescriptions, */ padDiagnostic } = newData;
      // const padId = pad.id;

      return {
        ...state,
        loading: false,
        pad: {
          ...pad,
          loadedData: pad
        },
        padVisits: {
          ...state.padVisits,
          loadedData: padVisits,
          screenData: preparePadVisits(padVisits),
          submitData: []
        },
        // padPrescription: {
        //   ...state.padPrescription,
        //   loadedData: preparePadPrescription(padPrescriptions),
        //   screenData: preparePadPrescription(padPrescriptions, padId),
        //   submitData: []
        // },
        padDiagnostic: {
          ...state.padDiagnostic,
          loadedData: padDiagnostic,
          screenData: padDiagnostic,
          submitData: []
        }
      };
    }

    case `${TEMPLATE_NAME}_SAVE_PAD`: {
      const newData = _.cloneDeep(action.payload);
      const pad = newData.data;
      const { loadedData } = state.pad;
      return {
        ...state,
        loading: false,
        pad: {
          ...pad,
          loadedData
        }
      };
    }

    case `${TEMPLATE_NAME}_SAVE_PAD_VISIT`: {
      const newData = _.cloneDeep(action.payload);
      const padVisit = newData.data;

      const { screenData, submitData } = state.padVisits;

      const code = codeGeneretor();

      const addPadVisit = new buildPadVisit(padVisit)
        .addPadVisitType(CREATION)
        .addPadVisitCode(code)
        .addStatus(1)
        .getPadVisit();

      return {
        ...state,
        loading: false,
        padVisits: {
          ...state.padVisits,
          screenData: [...screenData, addPadVisit],
          submitData: [...submitData, addPadVisit]
        }
      };
    }

    case `${TEMPLATE_NAME}_EDIT_PAD_VISIT`: {
      const newData = _.cloneDeep(action.payload);
      // const padVisit = newData.data;

      const pScreenData = [...state.padVisits.screenData];
      const pSubmitData = [...state.padVisits.submitData];

      const padVisit = new buildPadVisit({ ...newData.data }).getPadVisit();

      const screenData = new buildPadVisits(pScreenData, new buildPadVisit())
        .replace(padVisit)
        .getPadVisits();

      const submitData = new buildPadVisits(pSubmitData, new buildPadVisit())
        .remove(padVisit.code)
        .add(padVisit)
        .getPadVisits();

      return {
        ...state,
        loading: false,
        padVisits: {
          ...state.padVisits,
          screenData,
          submitData
        }
      };
    }

    case `${TEMPLATE_NAME}_UPDATE_PAD_VISIT`: {
      const newData = _.cloneDeep(action.payload);
      // const padVisit = newData.data;

      const pLoadedData = [...state.padVisits.loadedData];
      const pScreenData = [...state.padVisits.screenData];
      const pSubmitData = [...state.padVisits.submitData];

      const padVisit = new buildPadVisit({ ...newData.data }).setUpdateStatus().getPadVisit();

      const [padVisitOriginal] = pLoadedData.filter(pVisit => pVisit.id === padVisit.id);

      const isSamePadVisits = (padVisitOriginal, currentPadVisit) => {
        const { frequencyAmount, totalAmount, ...rest } = currentPadVisit;

        const cPadVisit = {
          totalAmount: parseInt(totalAmount),
          frequencyAmount: parseInt(frequencyAmount),
          ...rest
        };

        return _.isEqual(padVisitOriginal, cPadVisit);
      };

      let currentPadVisit = { ...padVisit };
      delete currentPadVisit.itHasBeenUpdated;

      const isPadVisitReturningToItsOriginalState = isSamePadVisits(
        padVisitOriginal,
        currentPadVisit
      );

      let screenData = [];
      let submitData = [];
      if (isPadVisitReturningToItsOriginalState) {
        //
        screenData = new buildPadVisits(pScreenData, new buildPadVisit())
          .replace(padVisitOriginal)
          .getPadVisits();

        submitData = new buildPadVisits(pSubmitData, new buildPadVisit())
          .remove(padVisitOriginal.code)
          .getPadVisits();
      } else {
        screenData = new buildPadVisits(pScreenData, new buildPadVisit())
          .replace(padVisit)
          .getPadVisits();

        submitData = new buildPadVisits(pSubmitData, new buildPadVisit())
          .remove(padVisit.code)
          .add(padVisit)
          .getPadVisits();
      }

      return {
        ...state,
        loading: false,
        padVisits: {
          ...state.padVisits,
          screenData,
          submitData
        }
      };
    }

    /**
     * PAD VISIT ALTERATION
     */
    case `${TEMPLATE_NAME}_CHANGE_PAD_VISIT`: {
      const newData = action.payload;
      const padVisit = newData.data;

      const padVisitIdForAlteration = padVisit.padVisitAlterId || padVisit.id;

      const cPadVisit = new buildPadVisit({ ...padVisit })
        .addPadVisitAlterId(padVisitIdForAlteration)
        .setUpdateStatus()
        .addPadVisitType(ALTERATION)
        .getPadVisit();

      const pLoadedData = [...state.padVisits.loadedData];
      const pScreenData = [...state.padVisits.screenData];
      const pSubmitData = [...state.padVisits.submitData];

      const [padVisitOriginal] = pLoadedData.filter(pVisit => pVisit.code === padVisit.code);

      const isSamePadVisits = (padVisitOriginal, padVisit) => {
        return (
          // padVisitOriginal.padVisitType === padVisit.padVisitType &&
          padVisitOriginal.frequencyAmount === parseInt(padVisit.frequencyAmount) &&
          padVisitOriginal.frequencyId === parseInt(padVisit.frequencyId) &&
          padVisitOriginal.totalAmount === parseInt(padVisit.totalAmount) &&
          padVisitOriginal.responsibleType === parseInt(padVisit.responsibleType)
        );
      };

      const isPadVisitReturningToItsOriginalState = isSamePadVisits(padVisitOriginal, padVisit);

      let screenData = [];
      let submitData = [];

      if (isPadVisitReturningToItsOriginalState) {
        screenData = new buildPadVisits(pScreenData, new buildPadVisit())
          .replace(padVisitOriginal)
          .getPadVisits();

        submitData = new buildPadVisits(pSubmitData, new buildPadVisit())
          .remove(padVisitOriginal.code)
          .getPadVisits();
      } else {
        screenData = new buildPadVisits(pScreenData, new buildPadVisit())
          .replace(cPadVisit)
          .getPadVisits();

        submitData = new buildPadVisits(pSubmitData, new buildPadVisit())
          .remove(cPadVisit.code)
          .add(cPadVisit)
          .getPadVisits();
      }

      return {
        ...state,
        loading: false,
        padVisits: {
          ...state.padVisits,
          screenData,
          submitData
        }
      };
    }

    case `${TEMPLATE_NAME}_REMOVE_PAD_VISIT`: {
      const newData = _.cloneDeep(action.payload);
      const padVisit = newData.data;

      const pScreenData = [...state.padVisits.screenData];
      const pSubmitData = [...state.padVisits.submitData];

      const screenData = pScreenData.filter(pVisit => pVisit.code !== padVisit.code);
      const submitData = pSubmitData.filter(pVisit => pVisit.code !== padVisit.code);

      return {
        ...state,
        loading: false,
        padVisits: {
          ...state.padVisits,
          screenData,
          submitData
        }
      };
    }

    case `${TEMPLATE_NAME}_CHANGE_STATUS_PAD_VISIT`: {
      const newData = _.cloneDeep(action.payload);
      const padVisit = newData.data;

      const status = padVisit.status ? 0 : 1;

      const cPadVisit = new buildPadVisit({ ...padVisit }).addStatus(status).getPadVisit();

      const pLoadedData = [...state.padVisits.loadedData];
      const pScreenData = [...state.padVisits.screenData];
      const pSubmitData = [...state.padVisits.submitData];

      const [padVisitOriginal] = pLoadedData.filter(pVisit => pVisit.id === padVisit.id);

      const isPadVisitReturningToItsOriginalState = padVisitOriginal.status === cPadVisit.status;

      let screenData = [];
      let submitData = [];

      if (isPadVisitReturningToItsOriginalState) {
        screenData = new buildPadVisits(pScreenData, new buildPadVisit())
          .replace(padVisitOriginal)
          .getPadVisits();

        submitData = new buildPadVisits(pSubmitData, new buildPadVisit())
          .remove(padVisitOriginal.code)
          .getPadVisits();
      } else {
        screenData = new buildPadVisits(pScreenData, new buildPadVisit())
          .replace(cPadVisit)
          .getPadVisits();

        submitData = new buildPadVisits(pSubmitData, new buildPadVisit())
          .remove(cPadVisit.code)
          .add(cPadVisit)
          .getPadVisits();
      }

      return {
        ...state,
        loading: false,
        padVisits: {
          ...state.padVisits,
          screenData,
          submitData
        }
      };
    }

    case `${TEMPLATE_NAME}_SUSPEND_PAD_VISIT`: {
      const newData = _.cloneDeep(action.payload);
      const padVisit = newData.data;

      const pScreenData = [...state.padVisits.screenData];
      const pSubmitData = [...state.padVisits.submitData];

      const padVisitIdForSuspension = padVisit.padVisitAlterId || padVisit.id;

      const cPadVisit = new buildPadVisit({ ...padVisit })
        .addPadVisitAlterId(padVisitIdForSuspension)
        .addPadVisitType(SUSPENSION)
        .getPadVisit();

      const screenData = new buildPadVisits(pScreenData, new buildPadVisit())
        .replace(cPadVisit)
        .getPadVisits();

      const submitData = new buildPadVisits(pSubmitData, new buildPadVisit())
        .add(cPadVisit)
        .getPadVisits();

      return {
        ...state,
        loading: false,
        padVisits: {
          ...state.padVisits,
          screenData,
          submitData
        }
      };
    }

    case `${TEMPLATE_NAME}_UNSUSPEND_PAD_VISIT`: {
      const newData = _.cloneDeep(action.payload);
      const padVisit = newData.data;

      const pLoadedData = [...state.padVisits.loadedData];
      const pScreenData = [...state.padVisits.screenData];
      const pSubmitData = [...state.padVisits.submitData];

      const [padVisitOriginal] = pLoadedData.filter(pVisit => pVisit.id === padVisit.id);

      const screenData = new buildPadVisits(pScreenData, new buildPadVisit())
        .replace(padVisitOriginal)
        .getPadVisits();

      const submitData = new buildPadVisits(pSubmitData, new buildPadVisit())
        .remove(padVisit.code)
        .getPadVisits();

      return {
        ...state,
        loading: false,
        padVisits: {
          ...state.padVisits,
          screenData,
          submitData
        }
      };
    }

    /**
     *  PAD DIAGNOSTIC
     */

    case `${TEMPLATE_NAME}_SAVE_PAD_DIAGNOSTIC`: {
      const newData = _.cloneDeep(action.payload);
      const padDiagnostic = newData.data;

      const { screenData, submitData } = state.padDiagnostic;

      const code = codeGeneretor();

      const addPadDiagnostic = new buildPadDiagnostic(padDiagnostic)
        .addPadDiagnosticType(CREATION)
        .addPadDiagnosticCode(code)
        .addStatus(1)
        .getPadDiagnostic();

      return {
        ...state,
        loading: false,
        padDiagnostic: {
          ...state.padDiagnostic,
          screenData: [...screenData, addPadDiagnostic],
          submitData: [...submitData, addPadDiagnostic]
        }
      };
    }

    case `${TEMPLATE_NAME}_REMOVE_PAD_DIAGNOSTIC`: {
      const newData = _.cloneDeep(action.payload);
      const padDiagnostic = newData.data;

      const pScreenData = [...state.padDiagnostic.screenData];
      const pSubmitData = [...state.padDiagnostic.submitData];

      const screenData = pScreenData.filter(pDiagnostic => pDiagnostic.code !== padDiagnostic.code);
      const submitData = pSubmitData.filter(pDiagnostic => pDiagnostic.code !== padDiagnostic.code);

      return {
        ...state,
        loading: false,
        padDiagnostic: {
          ...state.padDiagnostic,
          screenData,
          submitData
        }
      };
    }
    case `${TEMPLATE_NAME}__CHANGE_STATUS_DIAGNOSTIC`: {
      const newData = _.cloneDeep(action.payload);
      const padDiagnostic = newData.data;

      const status = padDiagnostic.status ? 0 : 1;

      const cPadDiagnostic = new buildPadDiagnostic({ ...padDiagnostic })
        .addStatus(status)
        .getPadDiagnostic();

      const pLoadedData = [...state.padDiagnostic.loadedData];
      const pScreenData = [...state.padDiagnostic.screenData];
      const pSubmitData = [...state.padDiagnostic.submitData];

      const [padDiagnosticOriginal] = pLoadedData.filter(
        pDiagnostic => pDiagnostic.id === padDiagnostic.id
      );

      const isPadDiagnosticReturningToItsOriginalState =
        padDiagnosticOriginal.status === cPadDiagnostic.status;

      let screenData = [];
      let submitData = [];

      if (!padDiagnostic.id) {
        screenData = pScreenData.map(
          pDiagnostic => pDiagnostic.code === padDiagnostic.code && { ...padDiagnostic }
        );
        submitData = pSubmitData.map(
          pDiagnostic => pDiagnostic.code === padDiagnostic.code && { ...padDiagnostic }
        );
      } else if (isPadDiagnosticReturningToItsOriginalState) {
        screenData = new buildPadDiagnostics(pScreenData, new buildPadDiagnostic())
          .replace(padDiagnosticOriginal)
          .getPadDiagnostics();

        submitData = new buildPadDiagnostics(pSubmitData, new buildPadDiagnostic())
          .remove(padDiagnosticOriginal.code)
          .getPadDiagnostics();
      } else {
        screenData = new buildPadDiagnostics(pScreenData, new buildPadDiagnostic())
          .replace(cPadDiagnostic)
          .getPadDiagnostics();

        submitData = new buildPadDiagnostics(pSubmitData, new buildPadDiagnostic())
          .remove(cPadDiagnostic.code)
          .add(cPadDiagnostic)
          .getPadDiagnostics();
      }

      return {
        ...state,
        loading: false,
        padDiagnostic: {
          ...state.padDiagnostic,
          screenData,
          submitData
        }
      };
    }
    case `${TEMPLATE_NAME}__UPDATE_PAD_DIAGNOSTIC`: {
      const newData = _.cloneDeep(action.payload);

      const padDiagnostic = new buildPadDiagnostic({ ...newData.data })
        .setUpdateStatus()
        .getPadDiagnostic();

      const pLoadedData = [...state.padDiagnostic.loadedData];
      const pScreenData = [...state.padDiagnostic.screenData];
      const pSubmitData = [...state.padDiagnostic.submitData];

      const [padDiagnosticOriginal] = pLoadedData.filter(
        pDiagnostic => pDiagnostic.id === padDiagnostic.id
      );

      const isSamepadDiagnostic = (padDiagnosticOriginal, currentPadDiagnostic) => {
        const { main, mainId, secondary, code, description, status, id } = padDiagnosticOriginal;
        const {
          main: cMain,
          mainId: cMainId,
          secondary: cSecondary,
          code: cCode,
          description: cDescription,
          status: cStatus,
          id: cId
        } = currentPadDiagnostic;

        const originalPropertiesToCompare = {
          main,
          mainId,
          secondary,
          code,
          description,
          status,
          id
        };
        const cPadDiagnostic = {
          main: cMain,
          mainId: cMainId,
          secondary: cSecondary,
          code: cCode,
          description: cDescription,
          status: cStatus,
          id: cId
        };

        return _.isEqual(originalPropertiesToCompare, cPadDiagnostic);
      };

      let currentPadDiagnostic = { ...padDiagnostic };
      delete currentPadDiagnostic.itHasBeenUpdated;

      let screenData = [];
      let submitData = [];

      if (!padDiagnostic.id) {
        screenData = pScreenData.map(
          pDiagnostic => pDiagnostic.code === padDiagnostic.code && { ...padDiagnostic }
        );
        submitData = pSubmitData.map(
          pDiagnostic => pDiagnostic.code === padDiagnostic.code && { ...padDiagnostic }
        );
      } else {
        const isPadDiagnosticReturningToItsOriginalState = isSamepadDiagnostic(
          padDiagnosticOriginal,
          currentPadDiagnostic
        );

        if (isPadDiagnosticReturningToItsOriginalState) {
          screenData = new buildPadDiagnostics(pScreenData, new buildPadDiagnostic())
            .replace(padDiagnosticOriginal)
            .getPadDiagnostics();

          submitData = new buildPadDiagnostics(pSubmitData, new buildPadDiagnostic())
            .remove(padDiagnosticOriginal.code)
            .getPadDiagnostics();
        } else {
          screenData = new buildPadDiagnostics(pScreenData, new buildPadDiagnostic())
            .replace(padDiagnostic)
            .getPadDiagnostics();

          submitData = new buildPadDiagnostics(pSubmitData, new buildPadDiagnostic())
            .remove(padDiagnostic.code)
            .add(padDiagnostic)
            .getPadDiagnostics();
        }
      }

      return {
        ...state,
        loading: false,
        padDiagnostic: {
          ...state.padDiagnostic,
          screenData,
          submitData
        }
      };
    }

    /**
     * PAD PRESCRIPTION
     */
    // case `${TEMPLATE_NAME}__EDIT_PRESCRIPTION`: {
    //   const newData = action.payload;
    //   const pLoadedData = [...state.padPrescription.loadedData];
    //   const pScreenData = [...state.padPrescription.screenData];
    //   const pSubmitData = [...state.padPrescription.submitData];

    //   const padPrescription = new buildPadPrescription({ ...newData.data })
    //     .setUpdateStatus()
    //     .getPadPrescription();

    //   // const properties = padPrescription.medicamentId
    //   //   ? MEDICAMENT_PROPERTIES_COMPARE
    //   //   : padPrescription.dietId
    //   //   ? NUTRITION_PROPERTIES_COMPARE
    //   //   : PROCEDURES_PROPERTIES_COMPARE;

    //   const [padPrescriptionOriginal] = pLoadedData.filter(
    //     pPrescription => pPrescription.id === padPrescription.id
    //   );

    //   // const valideToConverte = value => {
    //   //   return isNaN(parseFloat(value)) ? value : parseFloat(value);
    //   // };

    //   // const isSamePadPrescription = (padPrescriptionOriginal, currentPadPrescription) => {
    //   //   let original = { ..._.pick({ ...padPrescriptionOriginal }, properties) };
    //   //   let current = { ..._.pick({ ...currentPadPrescription }, properties) };
    //   //   // eslint-disable-next-line
    //   //   for (let row of properties) {
    //   //     original[row] = valideToConverte(original[row]);
    //   //     current[row] = valideToConverte(current[row]);
    //   //   }
    //   //   return isEqual(original, current);
    //   // };

    //   let currentPadPrescription = { ...padPrescription };
    //   delete currentPadPrescription.itHasBeenUpdated;

    //   const isPadPrescriptionReturningToItsOriginalState = compareObjects(
    //     padPrescriptionOriginal,
    //     currentPadPrescription,
    //     ['kits']
    //   );

    //   let screenData = [];
    //   let submitData = [];
    //   if (isPadPrescriptionReturningToItsOriginalState) {
    //     //
    //     screenData = new buildPadPrescriptions(pScreenData, new buildPadPrescription())
    //       .replace(padPrescriptionOriginal)
    //       .getPadPrescriptions();

    //     submitData = new buildPadPrescriptions(pSubmitData, new buildPadPrescription())
    //       .remove(padPrescriptionOriginal.code)
    //       .getPadPrescriptions();
    //   } else {
    //     screenData = new buildPadPrescriptions(pScreenData, new buildPadPrescription())
    //       .replace(padPrescription)
    //       .getPadPrescriptions();

    //     submitData = new buildPadPrescriptions(pSubmitData, new buildPadPrescription())
    //       .remove(padPrescription.code)
    //       .add(padPrescription)
    //       .getPadPrescriptions();
    //   }

    //   return {
    //     ...state,
    //     loading: false,
    //     padPrescription: {
    //       ...state.padPrescription,
    //       screenData,
    //       submitData
    //     }
    //   };
    // }
    // case `${TEMPLATE_NAME}__REMOVE_PRESCRIPTION`: {
    //   const newData = _.cloneDeep(action.payload);
    //   const padPrescription = newData.data;

    //   const pScreenData = [...state.padPrescription.screenData];
    //   const pSubmitData = [...state.padPrescription.submitData];

    //   const screenData = pScreenData.filter(pPrescrip => pPrescrip.code !== padPrescription.code);
    //   const submitData = pSubmitData.filter(pPrescrip => pPrescrip.code !== padPrescription.code);

    //   return {
    //     ...state,
    //     loading: false,
    //     padPrescription: {
    //       ...state.padPrescription,
    //       screenData,
    //       submitData
    //     }
    //   };
    // }
    // case `${TEMPLATE_NAME}__ADD_PRESCRIPTION`: {
    //   const newData = action.payload;
    //   const padPrescription = newData.data;

    //   const { screenData, submitData } = state.padPrescription;

    //   const code = codeGeneretor();

    //   const addPadPrescription = new buildPadPrescription(padPrescription)
    //     .addPadPrescriptionCode(code)
    //     .addStatus(STATUS.ACTIVE)
    //     .getPadPrescription();

    //   const indexScreen = submitData.findIndex(pPrescription =>
    //     comparePrescription(pPrescription, addPadPrescription)
    //   );
    //   const indexSubmit = submitData.findIndex(pPrescription =>
    //     comparePrescription(pPrescription, addPadPrescription)
    //   );

    //   return {
    //     ...state,
    //     loading: false,
    //     padPrescription: {
    //       ...state.padPrescription,
    //       screenData: indexScreen !== -1 ? [...screenData] : [...screenData, addPadPrescription],
    //       submitData: indexSubmit !== -1 ? [...submitData] : [...submitData, addPadPrescription]
    //     }
    //   };
    // }
    // case `${TEMPLATE_NAME}__CHANGE_STATUS_PRESCRIPTION`: {
    //   const newData = _.cloneDeep(action.payload);
    //   const padPrescription = newData.data;

    //   const status = padPrescription.status ? 0 : 1;

    //   const cPadPrescription = new buildPadPrescription({ ...padPrescription })
    //     .addStatus(status)
    //     .getPadPrescription();

    //   const pLoadedData = [...state.padPrescription.loadedData];
    //   const pScreenData = [...state.padPrescription.screenData];
    //   const pSubmitData = [...state.padPrescription.submitData];

    //   const [padPrescriptionOriginal] = pLoadedData.filter(pPre => pPre.id === padPrescription.id);

    //   const isPadPrescriptionReturningToItsOriginalState =
    //     padPrescriptionOriginal.status === cPadPrescription.status;

    //   let screenData = [];
    //   let submitData = [];

    //   if (isPadPrescriptionReturningToItsOriginalState) {
    //     screenData = pScreenData.map(pPrescrip => {
    //       const shouldReplace = pPrescrip.id === padPrescriptionOriginal.id;
    //       if (shouldReplace) return padPrescriptionOriginal;
    //       return pPrescrip;
    //     });

    //     submitData = pSubmitData.filter(pPrescrip => {
    //       const shouldKeep = pPrescrip.id !== padPrescriptionOriginal.id;
    //       return shouldKeep;
    //     });
    //   } else {
    //     screenData = pScreenData.map(pPrescrip => {
    //       const shouldReplace = pPrescrip.id === cPadPrescription.id;
    //       if (shouldReplace) return cPadPrescription;
    //       return pPrescrip;
    //     });

    //     submitData = [...pSubmitData, cPadPrescription];
    //   }

    //   return {
    //     ...state,
    //     loading: false,
    //     padPrescription: {
    //       ...state.padPrescription,
    //       screenData,
    //       submitData
    //     }
    //   };
    // }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
